import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Formik, Field, FieldArray } from "formik";
import * as moment from "moment";
import Select from 'react-select';
import Spinner from 'web/components/Spinner'
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import FileUploader from 'web/components/FileUploader';
import { Modal, ModalBody } from 'reactstrap';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { initialValues, VALIDATION_SCHEMA, defaultPalletFormData } from "web/components/utils/pickupOrderDetailsModalUtils";
import { PickupDetailsModalWrapper, PickupDetailsModalContentWrapper } from "./modalStyled";
import CloseIcon from "web/assets/images/CloseIcon.png";
import DatePickerIcon from 'web/assets/svg/DatePickerIcon';
import { palletTypeOptions } from "./Constants";
import NumberInput from "web/components/form-elements/NumberInput";
import TextArea from 'web/components/form-elements/TextArea';
import DatePicker from "web/components/DatePicker";
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import { uploadSpec } from "redux/actions/postLoad";
import { orderPickedApi, getPalletDetailsApi } from "redux/actions/myPickupOrders";

function PickupDetailsModal(props) {
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)
  const { modalData } = props
  const token = localStorage.getItem("token")
  const dispatch = useDispatch();
  let history = useHistory();
  const [vendorPalletTypeOptions, setVendorPalletTypeOptions] = useState(palletTypeOptions)
  const [loader, setLoader] = useState(false)
  const [pickupDetailsStore, setPickupDetailsStore] = useState()
  const [alertModal, setAlertModal] = useState(false)
  const [alertModalContent, setAlertModalContent] = useState('')
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [alertType, setModalType] = useState()

  useEffect(() => {
    getVendorPalletList()
  }, [])

  const getVendorPalletList = async () => {
    let data = {
      buyBackId: modalData?.buyBackId,
      vendorLocationId: modalData?.sellerLocationId || localStorage.getItem('locationID')
    }
    let response = await dispatch(getPalletDetailsApi(data, token));
    if (response?.feeDetails) {
      const labels = { "GRADE_A_48x40": "Grade A", "GRADE_A1_48x40": "Grade A1", "GRADE_B_48x40": "Grade B", "ODD": "Odd", "SCRAP": "Scrap" };
      const formPalletOptions = response?.feeDetails.map(item => ({
        label: labels[item.pickupPalletType],
        value: item.pickupPalletType
      }));
      setVendorPalletTypeOptions(formPalletOptions)
    } else {
      if (response?.statusCode === 401) {
        history.push('./sign-in')
      }
    }
  }

  const updateFieldValue = (setFieldValue, formValues, index, key, value) => {
    let cValue = formValues.palletTypeFormData;
    cValue[index][key] = value;
    setFieldValue('palletTypeFormData', cValue);

    //update the qty diff
    let totalOriginalQty = modalData.quantity
    let buyerEnteredQtySum = formValues?.palletTypeFormData.filter(data => (data.qty !== ''))
      .map(data => parseInt(data.qty)).reduce((sum, qty) => sum + qty, 0)
    if (buyerEnteredQtySum && buyerEnteredQtySum !== 0) {
      let quantityDiffPercentvalue = (((buyerEnteredQtySum - totalOriginalQty) / totalOriginalQty) * 100).toFixed(2)
      setFieldValue('quantityDiffPercent', quantityDiffPercentvalue)
    }
  }

  const submitForm = async (values) => {
    setPickupDetailsStore(values)
    if (Math.abs(values.quantityDiffPercent) > 6) {
      const qtyDiffInt = values.quantityDiffPercent > 0 ? 'greater' : 'less';
      setYesNoModalContent(`The quantity you recorded is ${qtyDiffInt} than the original estimated pickup quantity. Would you like to continue?`);
      setYesNoModal(true);
      setModalType('claimRaised');
    } else {
      pickupApiFunction(values);
    }
  }

  const pickupApiFunction = async (values, redirectType) => {
    setLoader(true)
    let documents = values?.documents || []
    let formData = new FormData();
    documents.map((data) => formData.append("uploadSpecification", data))
    let uploadResponse = await dispatch(uploadSpec(formData, ''));
    if (uploadResponse.status === "SUCCESS") {
      let data = {
        locationId: modalData?.sellerLocationId || localStorage.getItem('locationID'),
        orderId: modalData?.orderId,
        actualPickedupDate: moment(values?.actualPickupDate).format('MM-DD-YYYY'),
        comments: values?.comment,
        pickupPallets: values?.palletTypeFormData,
        uploadedDocs: uploadResponse.payload
      }
      let response = await dispatch(orderPickedApi(data, token));
      if (response?.success) {
        setLoader(false)
        setModalType(redirectType === 'claimRaise' ? 'claimRaiseSuccess' : 'orderPickedUpSuccess')
        setAlertModalContent(redirectType === 'claimRaise' ? 'Thank you. This order has been moved to the Claims section for a PalletTrader admin to review. They will be in contact with you soon.' : response?.data?.msg);
        setAlertModal(!alertModal)
      } else {
        setLoader(false)
        if (response?.statusCode === 401) {
          history.push('./sign-in')
        } else {
          setAlertModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setAlertModal(!alertModal);
        }
      }
    } else {
      if (uploadResponse?.statusCode === 401) {
        history.push('./sign-in')
      } else {
        setLoader(false)
        setAlertModal(!alertModal)
        setAlertModalContent(uploadResponse?.data?.error?.message || 'File upload failed, please try again.');
      }
    }
  }

  const fetchRemainingPalletOptions = (vendorPalletTypeOptions, values) => {
    let selectedValues = values?.palletTypeFormData.filter(data => data.palletType !== '').map(data => data.palletType) || []
    let remainingPalletOptions = vendorPalletTypeOptions
    if (selectedValues.length > 0) remainingPalletOptions = vendorPalletTypeOptions.filter(data => !(selectedValues.includes(data.value)))
    return remainingPalletOptions
  }

  const calculateTotalQty = (values) => {
    let buyerEnteredQtySum = 0
    buyerEnteredQtySum = values?.palletTypeFormData.filter(data => (data.qty !== ''))
      .map(data => parseInt(data.qty)).reduce((sum, qty) => sum + qty, 0)
    return buyerEnteredQtySum
  }

  return (
    <PickupDetailsModalWrapper>
      <Modal isOpen={true} centered={true} size={'lg'} className="pickuporder-details-modal">
        <PickupDetailsModalContentWrapper>
          <ModalBody>
            {(loaderVisible || loader) && <Spinner />}
            <Formik
              initialValues={initialValues(modalData)}
              validationSchema={VALIDATION_SCHEMA()}
            >
              {(formikProps) => {
                const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
                return (
                  <div className="outer-wrapper">
                    <div className="main-header">
                      <div>
                        <h4 style={{ textAlign: 'center' }}>Pickup Order Details</h4>
                        <p style={{ fontSize: '15px' }}>Please complete the below form by recording the pallet types and quantities received. Use the (+) sign to add more rows as needed. Please upload the signed pickup receipt and acknowledge the checkbox to complete the pickup form.</p>
                      </div>
                      <img src={CloseIcon} alt="close-icon" onClick={() => props.closeModal()} />
                    </div>
                    <div className="location-details-styles">
                      <div>
                        <p>PU Location Name</p>
                        <span>{modalData?.pickupLocation?.locationName}</span>
                      </div>
                      <div>
                        <p>Pickup Address</p>
                        <span>{modalData?.pickupLocation?.address1}, {modalData.pickupLocation?.city}, {stateConvert(modalData.pickupLocation?.state) || modalData.pickupLocation?.state} {modalData.pickupLocation?.zipCode}</span>
                      </div>
                    </div>
                    <div className="pickup-details-styles">
                      <div>
                        <p>Requested Date</p>
                        <div className="date-picker-style">
                          <DatePickerIcon />
                          <span>{moment(modalData?.pickupDate).format('MM/DD/YYYY')}</span>
                        </div>
                      </div>
                      <div>
                        <p>Requested Window</p>
                        <span>{modalData?.pickupAppointmentStartTime} <span style={{ margin: '0 10px' }}>To</span> {modalData?.pickupAppointmentEndTime}</span>
                      </div>
                      <div>
                        <p>PO Number</p>
                        <span>{modalData?.poNumber}</span>
                      </div>
                      <div>
                        <p>Estimated Qty</p>
                        <span>{modalData?.quantity}</span>
                      </div>
                    </div>
                    <hr />
                    <div className="pallet-type-styles">
                      <FieldArray name="palletTypeFormData">
                        {({ insert, remove, push }) => (
                          <>
                            <div className="header">
                              <p>Pallet Type<span className="star">*</span></p>
                              <p>Quantity<span className="star">*</span></p>
                            </div>
                            <div className="content">
                              {values.palletTypeFormData.map((currentRow, index) => (
                                <div key={`adding-new-${index}`} className="content-rows">
                                  <div>
                                    <Select
                                      id="palletType"
                                      name={`palletTypeFormData.[${index}].palletType`}
                                      value={values.palletTypeFormData[index].palletType ? vendorPalletTypeOptions.find(option => option.value === currentRow.palletType) : null}
                                      onChange={(selectedOption) => {
                                        updateFieldValue(setFieldValue, values, index, "palletType", selectedOption.value);
                                      }}
                                      options={fetchRemainingPalletOptions(vendorPalletTypeOptions, values)} // once selected option should be removed from the list
                                      placeholder=""
                                    />
                                  </div>
                                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '70%' }}>
                                      <NumberInput
                                        name={`palletTypeFormData.[${index}].qty`}
                                        showErrorMessages={true}
                                        placeholder=""
                                        decimalScale={0}
                                        maxLength={4}
                                        onChangeHandler={(val) => {
                                          updateFieldValue(setFieldValue, values, index, "qty", val);
                                        }}
                                      />
                                    </div>
                                    <div>
                                      {index > 0 ?
                                        (<button
                                          className="delete-button"
                                          onClick={() => {
                                            const updatedFormValues = [...values.palletTypeFormData];
                                            updatedFormValues.splice(index, 1, defaultPalletFormData());
                                            setFieldValue('palletTypeFormData', updatedFormValues);
                                            remove(index);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </button>)
                                        :
                                        (vendorPalletTypeOptions?.length > 1 &&
                                          <button
                                            className="add-button"
                                            onClick={() => {
                                              if (values.palletTypeFormData.length < vendorPalletTypeOptions?.length) {
                                                push({ ...defaultPalletFormData() });
                                              }
                                            }}
                                          >
                                            <AddPlusIcon />
                                          </button>)
                                      }
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="content-rows">
                              <p style={{ textAlign: 'right', color: '#000' }}>Total Quantity : </p>
                              <h6><span className="total-qty-style">{calculateTotalQty(values)}</span></h6>
                            </div>
                          </>
                        )}
                      </FieldArray>
                    </div>
                    <hr />
                    <div className="bol-pickupDate-row">
                      <div style={{ minWidth: 'fit-content' }}>
                        <p style={{ margin: 0 }}>Actual Pickup Date<span className="star">*</span></p>
                        <DatePicker
                          name='actualPickupDate'
                          value={values.actualPickupDate}
                          type="returnNormalDate"
                          maxDOBirth={moment().endOf('day').toDate()}
                          callBackFun={(date, value) => {
                            setFieldValue('actualPickupDate', moment(date).format("MM/DD/YYYY"));
                          }}
                        />
                        {errors?.actualPickupDate && <span className="error-message">{errors?.actualPickupDate}</span>}
                      </div>
                      <div>
                        <FileUploader mandatory='no' buttonName='Upload Completed Form' onUploadOrRemove={(files) => setFieldValue('documents', files)} />
                      </div>
                    </div>
                    <div className="comment-section-style">
                      <p>Comment</p>
                      <TextArea
                        name="comment"
                        maxLength="200"
                      />
                    </div>
                    <div className="checkbox-section-style">
                      <CheckboxInput
                        name="acknowledgeCheck"
                        label="I acknowledge that all values supplied above are complete and accurate."
                        handleSelect={() => { }}
                      />
                    </div>
                    <div className="submit-button">
                      <button
                        disabled={!dirty || !isValid}
                        onClick={() => submitForm(values)}
                      >Submit</button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          </ModalBody>
        </PickupDetailsModalContentWrapper>
      </Modal>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
        alertType='success'
        callBackAlert={() => {
          if (alertType === 'orderPickedUpSuccess') {
            props.closeModal()
            props.pickedupSuccessCallBack()
          } else if (alertType === 'claimRaiseSuccess') {
            props.closeModal()
            props.claimRaisedSuccessCallBack()
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => setYesNoModal(!yesNomodal)}
        title=""
        content={yesNoModalContent}
        link={'/'}
        type={''}
        onClickHander={(val) => {
          setYesNoModal(!yesNomodal)
          if (val !== "no" && alertType === 'claimRaised') pickupApiFunction(pickupDetailsStore, 'claimRaise')
        }}
      />
    </PickupDetailsModalWrapper>
  );
}

export default PickupDetailsModal;
